module.exports = __webpack_public_path__ + "img/2a.c201f071.svg";